// react-select shared styling — teal/slate theme (spec §7).
// Used alongside CSS class overrides so the control matches native inputs.

const c = {
  primary: '#0E7490',
  primaryDark: '#155E75',
  primarySoft: '#E0F2FE',
  border: '#E2E8F0',
  ink: '#0F172A',
  muted: '#64748B',
  surface: '#FFFFFF',
  surface2: '#F1F5F9',
};

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 8,
    borderColor: state.isFocused ? c.primary : c.border,
    boxShadow: state.isFocused ? `0 0 0 3px ${c.primarySoft}` : 'none',
    '&:hover': { borderColor: c.primary },
    fontSize: '0.9rem',
  }),
  menu: (base) => ({ ...base, borderRadius: 8, overflow: 'hidden', zIndex: 30, boxShadow: '0 4px 12px rgba(15,23,42,0.08)' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.9rem',
    backgroundColor: state.isSelected ? c.primary : state.isFocused ? c.surface2 : c.surface,
    color: state.isSelected ? '#fff' : c.ink,
    cursor: 'pointer',
  }),
  multiValue: (base) => ({ ...base, backgroundColor: c.primarySoft, borderRadius: 6 }),
  multiValueLabel: (base) => ({ ...base, color: c.primaryDark, fontSize: '0.82rem' }),
  multiValueRemove: (base) => ({
    ...base,
    color: c.primaryDark,
    ':hover': { backgroundColor: c.primary, color: '#fff' },
  }),
  placeholder: (base) => ({ ...base, color: c.muted, fontSize: '0.9rem' }),
};

export const selectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: c.primary,
    primary25: c.surface2,
    primary50: c.primarySoft,
    primary75: c.primarySoft,
  },
});

export default selectStyles;
